"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _angleDown = _interopRequireDefault(require("./img/angleDown.svg"));
var _adult = _interopRequireDefault(require("./img/adult.svg"));
var _child = _interopRequireDefault(require("./img/child.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var ButtonTrigger = function ButtonTrigger(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    isCollapsed = _ref.isCollapsed,
    countOfAdults = _ref.countOfAdults,
    countOfChildren = _ref.countOfChildren,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var icons = (0, _react.useMemo)(function () {
    var adults = (0, _ramda.times)((0, _ramda.always)(_adult.default), countOfAdults);
    var children = (0, _ramda.times)((0, _ramda.always)(_child.default), countOfChildren);
    return (0, _ramda.concat)(adults, children);
  }, [countOfAdults, countOfChildren]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeTheme: _Button.THEMES.WHITE,
    className: (0, _classnames2.default)(_styles.default.button, _defineProperty({}, _styles.default.isCollapsed, isCollapsed)),
    contentClassName: _styles.default.content,
    disabled: disabled,
    icon: _angleDown.default,
    iconClassName: _styles.default.angle,
    size: _Button.SIZES.MEDIUM,
    theme: _Button.THEMES.WHITE,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    onClick: onClick
  }, t('BOOKING_SERVICES_TITLE'), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.icons
  }, mapIndexed(function (icon, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: _styles.default.icon,
      dangerouslySetInnerHTML: {
        __html: icon
      }
    });
  }, icons)));
};
ButtonTrigger.propTypes = {
  disabled: _propTypes.default.bool,
  countOfAdults: _propTypes.default.number.isRequired,
  countOfChildren: _propTypes.default.number.isRequired,
  isCollapsed: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(ButtonTrigger);